<template>
  <div class="vehicle-detail text-center mx-auto">
    <p class="fs-20 vehicle-detail-title"><b>Car details</b></p>
    <div v-for="(vehicleDetail, index) in vehicleDetails" :key="index"
        class="d-flex justify-content-between align-items-center vehicle-detail-item fs-14 text-left">
      <p class="vehicle-label ml-10 mb-0 font-weight-thin">{{ vehicleDetail.label }}:</p>
      <p class="mb-0 mr-10 text-right">
        <b style="text-transform: uppercase">{{
          displayInfo(vehicleDetail)
        }}</b>
      </p>
    </div>
  </div>
</template>

<script>
import {VEHICLE_DETAILS} from "@/config/constants"
import mixin from "@/mixins/common"
import { formatNumberWithComma } from "@/helper/utils"
import { blankOptionList } from "@/helper/constant"

export default {
  name: "VehicleDetail",
  props: ['vehicleInfo'],
  mixins: [mixin],
  data() {
    return {
      vehicleDetails: [...VEHICLE_DETAILS]
    }
  },
  methods: {
    formatKm(val) {
      if (val) {
        return formatNumberWithComma(val) + ' km'
      }
      return val
    },
    convertBadgeEdition(val) {
      if (val && !blankOptionList.includes(val)) {
        return val + ' ' + this.vehicleInfo.edition;
      } else if (val === '') {
        return 'N/A';
      }
      return val;
    },
    displayInfo(vehicleDetail) {
      const { key, label } = vehicleDetail;
      const value = this.vehicleInfo[key];
      switch (vehicleDetail.key) {
        case "color":
          return this.capitalizeFirstLetter(value);
        case "kms":
          return this.formatKm(value);
        case "badge":
          return this.convertBadgeEdition(value);
        default:
          return this.vehicleInfo.redbookDataMapper[label]
            ? this.vehicleInfo.redbookDataMapper[label][value] || value
            : value;
      }
    },
  },
  mounted() {
    if (this.vehicleInfo.model_year === '') {
      this.vehicleDetails.pop()
    }
    if (this.vehicleInfo.series === '') {
      this.vehicleDetails.splice(3, 1)
    }
  }
}
</script>

<style lang="scss">
.vehicle-detail {
  max-width: 354px;
  padding: 15px 20px 30px;
  margin-top: 41px;
  border: 1px solid #CBCBCB;
  border-radius: 20px;

  .vehicle-detail-title {
    margin-bottom: 25px;
  }

  .vehicle-detail-item {
    border-bottom: 1px solid #E6E6E6;
    height: 40px;

    .vehicle-item {
      margin-right: 10px;
      text-transform: uppercase;
      text-align: right;
    }

    &:first-of-type {
      border-top: 1px solid #E6E6E6;
    }

    .vehicle-label {
      width: 115px;
    }
  }
}

@media screen and (min-width: 768px) {
  .vehicle-detail {
    width: calc(50% - 15px) !important;
    max-width: 475px !important;
    min-height: 100% !important;
    padding: 16px 44px 0 !important;
    margin: 0 !important;

    .vehicle-detail-item .vehicle-label {
      width: 159px !important;
    }
  }
}
</style>
